module.exports = __webpack_public_path__ + "images/arr-bottom-green.svg?cda8645c1a4fbddc4bebc0090bead8c4";